import { ActionContext, Module } from "vuex";
import { RootState } from "@/store/index";

export interface NavigationState {
  pageTitle: string;
  subPageTitle: string | null;
  latestEntry: string | null;
  history: string[];
}

const navigationModule: Module<NavigationState, RootState> = {
  namespaced: true,
  state: () =>
    ({
      pageTitle: "Startseite",
      subPageTitle: null,
      history: [],
      latestEntry: null,
    } as NavigationState),
  mutations: {
    setCurrentPageTitle(state: NavigationState, name: string) {
      state.pageTitle = name;
      state.subPageTitle = null;
    },
    setCurrentSubPageTitle(state: NavigationState, name: string | null) {
      state.subPageTitle = name;
    },
    addHistory(state: NavigationState, link: string) {
      if (state.latestEntry !== link) {
        state.history.push(link);
        state.latestEntry = link;
      }
    },
    setLatestEntryFromHistory(state: NavigationState) {
      state.history.splice(state.history.length - 1, 1);
      state.latestEntry = state.history[state.history.length - 1];
    },
    clearHistory(state: NavigationState) {
      state.history = [];
      state.latestEntry = null;
    },
  },
  actions: {
    changePageTitle(
      context: ActionContext<NavigationState, RootState>,
      name: string
    ) {
      context.commit("setCurrentPageTitle", name);
    },
    changeSubPageTitle(
        context: ActionContext<NavigationState, RootState>,
        name: string | null
    ) {
      context.commit("setCurrentSubPageTitle", name);
    },
    addHistory(
      context: ActionContext<NavigationState, RootState>,
      link: string
    ) {
      context.commit("addHistory", link);
    },
    nextPreviousHistory(context: ActionContext<NavigationState, RootState>) {
      context.commit("setLatestEntryFromHistory");
    },
    clearHistory(context: ActionContext<NavigationState, RootState>) {
      context.commit("clearHistory");
    },
  },
};

export default navigationModule;
